var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacyPolicy"},[_c('div',{staticStyle:{"word-break":"break-all"},domProps:{"innerHTML":_vm._s(_vm.decodeStrConStr)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }